(function() {
  define('tlhComponentsAdminToolbar',['angular'], function() {
    'use strict';
    return angular.module('tlhComponentsAdminToolbar', []).component('tlhAdminToolbar', {
      templateUrl: '/assets/lib/angular/tlh/components/adminToolbar.html',
      bindings: {
        editable: '<',
        editOn: '<',
        admin: '<'
      },
      controller: [
        '$scope', '$window', 'TlhCmsEvents', 'TlhNotifierService', function($scope, $window, TlhCmsEvents, TlhNotifierService) {
          var disableActions, enableActions, handlePageModified, handlePageUnmodified, handleSaveFailed, handleSaveSuccess, reset, vm;
          vm = this;
          vm.$onInit = function() {
            return reset();
          };
          reset = function() {
            vm.pageModified = false;
            vm.saving = false;
            return vm.disabled = false;
          };
          $window.onbeforeunload = function() {
            var result;
            result = void 0;
            if (vm.pageModified) {
              result = 'En quittant cette page, vous perdrez vos modifications non enregistrées.';
            }
            return result;
          };
          vm.save = function() {
            if (!vm.disabled) {
              vm.saving = true;
              vm.disabled = true;
              return TlhNotifierService.send(TlhCmsEvents.SAVE_ALL);
            }
          };
          vm.cancel = function() {
            if (!vm.disabled) {
              return TlhNotifierService.send(TlhCmsEvents.CANCEL_ALL);
            }
          };
          handlePageModified = function() {
            return vm.pageModified = true;
          };
          handlePageUnmodified = function() {
            return reset();
          };
          handleSaveSuccess = function() {
            return reset();
          };
          handleSaveFailed = function() {
            vm.saving = false;
            return vm.disabled = false;
          };
          disableActions = function() {
            return vm.disabled = true;
          };
          enableActions = function() {
            return vm.disabled = false;
          };
          $scope.$on(TlhCmsEvents.PAGE_MODIFIED, handlePageModified);
          $scope.$on(TlhCmsEvents.PAGE_UNMODIFIED, handlePageUnmodified);
          $scope.$on(TlhCmsEvents.SAVE_SUCCESS, handleSaveSuccess);
          $scope.$on(TlhCmsEvents.SAVE_FAILED, handleSaveFailed);
          $scope.$on(TlhCmsEvents.DISABLE_ACTIONS, disableActions);
          $scope.$on(TlhCmsEvents.ENABLE_ACTIONS, enableActions);
        }
      ]
    });
  });

}).call(this);

//# sourceMappingURL=adminToolbar.js.map
;
